import { Component, forwardRef, Input } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';
import DOMPurify from 'dompurify';

@Component({
  selector: 'text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaComponent),
      multi: true,
    },
  ],
})
export class TextAreaComponent extends ControlValueAccessorDirective {
  @Input() placeholder: string = '';
  @Input() isContactPage:boolean = false;
  @Input() label: string = '';
  @Input() public readonly: boolean = false;
  @Input() public isDisabled: boolean = false;
  @Input() public control!: FormControl;

  constructor() {
    super();
  }

  public get Required(): boolean {
    return this.control?.hasValidator(Validators.required) ?? false;
  }

  public get Invalid(): boolean {
    return this.control?.invalid ?? false;
  }

  public get ShowError(): boolean {
    if (!this.control) return false;
    const { dirty, touched } = this.control;
    return this.Invalid ? dirty || touched : false;
  }

  sanitizeText(text: string): string {
  
    // Remove URLs using regex
    let cleanedText = text;
    cleanedText = cleanedText.replace(/https?:\/\/[^\s]+/g, '');

    return DOMPurify.sanitize(cleanedText, {
      ALLOWED_TAGS: [], // Remove all HTML tags
      ALLOWED_ATTR: [], // Remove all attributes
      SANITIZE_DOM: true, // Enable DOM sanitization
      USE_PROFILES: { html: false }, // Disable HTML profile to be extra strict
    });
  }

  preventPaste(event: any): void {
    event.preventDefault(); // Prevent pasting malicious input
    setTimeout(() => {
      this.value = ''; // Clear the pasted content
    }, 0);
  }

  preventPasteMobile(event: any): void {
    // Defensive check for value
    const removeDangerText = () => {
      if (this.value) {

        const cleanedValue = this.sanitizeText(this.value);
        if (cleanedValue !== this.value) {
          this.value = cleanedValue;
          this.onChange(this.value);
        }
      }
    };

    // Always sanitize on paste or insert
    if (
      event.inputType === 'insertFromPaste' ||
      event.inputType === 'insertText'
      // Don't prevent default to keep native paste behavior
    ) {
      // but immediately sanitize after paste
      setTimeout(removeDangerText, 0); // Let value update then sanitize
    }
  }
}
